import { get, post, baseURL } from './index'

export const registerMobileCheck = data => get('/user/exist', data)
export const getCaptcha = `${baseURL}/captcha` // 获取图形验证码
// export const getCaptcha = 'http://simboss-hulk-feature-card-device-v2.test.simboss.com/captcha' // 获取图形验证码
export const sendSmsCode = params => get('/sendSmsCode', params) // 发送短信验证码
export const userRegister = data => post('/user/register', data)
export const resetPassword = data => post('/user/resetPassword', data)
export const userLogin = data => post('/login', data)
export const superLogin = params => get('/goToInferior', params)
export const backToSuperior = () => get('/backToSuperior')
export const desensitizationShow = (data) => post('/desensitization/show', data)
